import { FloatingLabel, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";
import { IsValid, ValidationCssClass } from "../Validation";
import IDatePickerProps from "./IDatePickerProps";
import styles from "../formFields.module.scss";
import dayjs from "dayjs";
import { mergeStyles } from "@fluentui/merge-styles";

export default function DatePicker(props: IDatePickerProps) {
    const { t } = useTranslation();

    const validationMessage = props.validationMessage || t("general.provideValue");
    
    let validationCssClass = ValidationCssClass(props.validation);
    let isValid = IsValid(props.validation);

    const value = props.value
        ? dayjs(props.value).format("YYYY-MM-DD")
        : "";

    const floatingLabelCssClass = mergeStyles("mb-3", props.required ? styles.required : null);
    
    return (
        <FloatingLabel  className={floatingLabelCssClass}
                        controlId={`txt-${uuid()}`}
                        label={props.label}>
            <Form.Control   type="date"
                            className={`${validationCssClass} ${styles.formControl}`}
                            value={value}
                            isValid={isValid}
                            disabled={props.disabled}
                            onChange={(e) => props.onChange(e.target.value ? new Date(e.target.value) : null!)}
                            />
            {
                isValid === false &&
                <div className="text-danger">
                    {validationMessage}
                </div>
            }
        </FloatingLabel>
    );
}